<template>
  <div class="layout">
    <page-header />
    <div style="page-content">
      <banners />
      <article-tabs @openCheckModule="openCheckModule" />
    </div>
    <page-footer />
    <check-module :checkModuleFalg="checkModuleFalg" @closeModule="closeModule()" />
  </div>
</template>
<script>
import PageHeader from '@/components/header/PageHeader'
import PageFooter from '@/components/footer/PageFooter'
import Banners from './modules/Banners'
import ArticleTabs from './modules/ArticleTabs'
import CheckModule from './modules/CheckModule'
import xy_config from '@/config/xy_config'
export default {
  name: 'Main',
  components: {
    PageHeader,
    PageFooter,
    Banners,
    ArticleTabs,
    CheckModule
  },
  data () {
    return {
      checkModuleFalg: false
    }
  },
  methods: {
    closeModule () {
      this.checkModuleFalg = false
    },
    openCheckModule () {
      const _that = this
      const tokenCookie = _that.$cookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        _that.$message({
          message: '登录后操作',
          duration: 1000,
          onClose: () => {
            window.location.href = '../login/login.html?to=' + escape(window.location.href)
          }
        })
        return
      }
      this.checkModuleFalg = true
    }
  }
}
</script>
<style lang="less" scoped>
.layout {
  height: 100vh;
}
</style>
